<template>
  <div class="">
    <section class="work-area pt-100 pb-70">
        <img class="background" src="/assets/img/background.jpg">
    </section>
  </div>
</template>

<script>
export default {
  name: 'Background',
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background{
  width: 100%;
}

</style>
